<template>
  <section class="nav-bar" :style="`background-color: ${getBackgroundColor}`">
    <div class="nav-bar__left">
      <router-link to="/"
        ><img class="nav-bar__left--logo" :src="logo"
      /></router-link>
      <router-link
        class="nav-bar__left--toggle"
        :to="isHomePage ? '/more' : '/'"
      >
        <div
          class="dot"
          :style="isHomePage ? 'float: left;' : 'float: right;'"
        ></div
      ></router-link>
    </div>
    <ul
      v-if="hasLinks"
      class="nav-bar__right"
      :style="`color: ${getLinkColor}`"
    >
      <li
        v-for="(link, i) in links"
        :key="i"
        class="nav-bar__right--item"
        v-scroll-to="
          link.name !== 'Brand guidelines' && {
            el: `#${link.scroll}`,
            duration: 500,
            lazy: false,
            easing: 'linear',
          }
        "
        @click="link.name === 'Brand guidelines' && toggleSideBar()"
      >
        <div>
          <img
            v-if="link.name === 'Brand guidelines' && !sideBarOpen"
            :src="require(`../assets/images/burger-${textColor}.svg`)"
          />
          <img
            class="close"
            v-if="link.name === 'Brand guidelines' && sideBarOpen"
            :src="require(`../assets/images/${textColor}-cross.svg`)"
          />{{
            link.name === 'Brand guidelines' && sideBarOpen
              ? 'Close'
              : link.name
          }}
        </div>
      </li>

      <li @click="authenticate" class="nav-bar__right--item">
        <img :src="require(`../assets/images/lock.svg`)" />
        {{ loginText }}
      </li>
      <li
        v-if="$isMobile()"
        @click="toggleSideBar"
        class="nav-bar__right--item-mobile"
      >
        <img :src="require(`../assets/images/burger-${textColor}.svg`)" />
      </li>
    </ul>
  </section>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    links: {
      type: Array,
      default: () => [],
      required: true,
    },
    backgroundColor: {
      type: String,
      default: 'orange',
      required: true,
    },
    textColor: {
      type: String,
      default: 'white',
      required: true,
    },
    logo: {
      type: String,
      default: '',
      required: true,
    },
    sideBarOpen: {
      type: Boolean,
      default: false,
      required: false,
    },
    isHomePage: {
      type: Boolean,
      default: true,
      required: true,
    },
  },
  data() {
    return {
      showSideBar: false,
    }
  },
  computed: {
    hasLinks() {
      return this.links.length > 0
    },
    getBackgroundColor() {
      if (this.backgroundColor === 'orange') return '#ff8000'
      return '#ffffff'
    },
    getLinkColor() {
      if (this.textColor === 'orange') return '#ff8000'
      if (this.textColor === 'white') return '#ffffff'
      return '#ff8000'
    },
    loginText() {
      return this.authState.isAuthenticated ? 'Sign out' : 'Sign in'
    },
  },
  methods: {
    toggleSideBar() {
      this.showSideBar = !this.sideBarOpen
      this.$emit('toggleSideBar', this.showSideBar)
    },
    updateRoute(name) {
      this.$router.push({ name })
    },
    authenticate() {
      return this.authState.isAuthenticated ? this.logout() : this.login()
    },
    login() {
      this.$auth.signInWithRedirect()
    },
    async logout() {
      await this.$auth.signOut()
      localStorage.removeItem('okta-token-storage')
      this.$router.push('/')
    },
  },
}
</script>

<style lang="scss">
$desktop: 1024px;
$tablet: 768px;
$mobile: 600px;

.nav-bar {
  padding: 10px 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 90%;
  top: 0;
  -webkit-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.05) 0px 8px 32px;
  -moz-box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.05) 0px 8px 32px;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 4px 16px,
    rgba(17, 17, 26, 0.05) 0px 8px 32px;
  z-index: 9999;
  @media (max-width: $tablet) {
    padding: 20px 5%;
  }
  &__left {
    display: flex;
    align-items: center;
    &--logo {
      cursor: pointer;
      max-width: 200px;
      margin-right: 50px;
      &:hover {
        opacity: 0.9;
        transform: scale(1.02);
      }
    }
    &--toggle {
      width: 50px;
      border: 2px solid var(--color-orange-1);
      border-radius: 30px;
      height: 20px;
      padding: 5px;
      margin: 0 auto;
      display: block;
      justify-content: space-around;
      .dot {
        background-color: var(--color-orange-1);
        border-radius: 50%;
        border: 2px solid var(--color-orange-1);
        height: 16px;
        width: 16px;
      }
    }
  }

  &__right {
    list-style: none;
    display: flex;
    font-weight: 600;
    &--item,
    &--item-login {
      margin: 0 30px;
      cursor: pointer;
      display: flex;
      &:hover {
        opacity: 0.9;
        transform: scale(1.02);
      }
      img {
        margin-right: 10px;
        width: 20px;
      }
      a {
        text-decoration: none;
      }
      .close {
        width: 12px;
      }
      @media (max-width: $tablet) {
        display: none;
      }
    }

    &--item-mobile {
      cursor: pointer;
      display: none;
      &:hover {
        opacity: 0.9;
        transform: scale(1.02);
      }
      img {
        margin-left: 10px;
      }
      @media (max-width: $tablet) {
        display: block;
        position: absolute;
        right: 10%;
        top: 30px;
      }
    }
  }
}
</style>
